import { useLang } from "@/lang";

const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-bei-navy py-7"
    >
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`whitespace-nowrap font-display text-2xl font-bold uppercase tracking-wide sm:text-3xl ${
                i % 2 === 0 ? "text-white" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="mx-8 h-2 w-2 rounded-full bg-bei-cyan sm:mx-12" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
